<template>
  <!--////////////////////////////////////////////// Hojas de Iframe ////////////////////////////////////////////////////////////-->
  <v-sheet
    v-if="editedIndex != -1"
    class="mx-auto"
    elevation="8"
    max-width="1200"
  >
    <v-slide-group
      v-model="modelhojas"
      class="pa-4"
      selected-class="bg-success"
      show-arrows
    >
      <v-slide-group-item
        v-for="n in sheet"
        :key="n"
        v-slot="{ toggle, selectedClass }"
      >
        <v-card
          color="blue-lighten-4"
          :class="['ma-4', selectedClass]"
          height="70"
          width="140"
          @click="
            toggle();
            editItem(n);
          "
        >
          <v-card-item>
            <div>
              <div align="center" class="text-caption">
                <v-icon> {{ n.icono }} </v-icon>
              </div>
              <div align="center" class="text-caption">
                {{ n.descripcion }}
              </div>
            </div>
          </v-card-item>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </v-sheet>
  <!--////////////////////////////////////////////// Dialogos Formulario ////////////////////////////////////////////////////////////-->
  <v-dialog v-model="dialogframeboton" persistent fullscreen>
    <v-card>
      <v-toolbar dark color="red-darken-4">
        <v-toolbar-title
          ><v-icon left> mdi-lock </v-icon> Seguros -
          {{ infollaves.Contrato }}-{{ infollaves.Document_ID }} -
          {{ infollaves.Ref_1 }}
        </v-toolbar-title>
        <v-toolbar-items>
          <v-btn
            class="d-none d-md-block"
            dark
            text
            @click="dialogframeboton = false"
            >Cerrar</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <!-- Consulta  Seguros ¡-->
        <card-seguros
          v-if="dialogframeboton"
          v-bind:pageiframe="dialogframeboton"
          v-on:update:pageiframe="dialogframeboton = $event"
          :infollaves="infollaves"
          :infopermisos="'0110'"
          :paramiframeuno="paramiframeuno"
          :TipoSeguro="TipoSeguro"
        ></card-seguros>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!--////////////////////////////////////////////// Formulario ////////////////////////////////////////////////////////////-->
  <v-form ref="form" autocomplete="off">
    <v-expansion-panels v-model="panel" multiple>
      <!--////////////////////////////////////////////// Seguros ////////////////////////////////////////////////////////////-->
      <v-expansion-panel v-if="TipoServicio == 6">
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-lock </v-icon>
            Último Seguro del contrato {{ infollaves.Contrato }} activo
            {{ infollaves.Ref_1 }}
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <!-- Seguros -->
          <v-tooltip location="bottom" color="white">
            <template v-slot:activator="{ props }">
              <v-icon
                @click="dialogframeboton = true"
                color="cyan"
                v-bind="props"
                >mdi-account-lock</v-icon
              >
            </template>
            <span>Agregar Seguro</span>
          </v-tooltip>
          <br />
          <br />
          <v-row v-if="ArraySeguros != null">
            <!--Tipo de seguro::-->
            <v-col cols="12" sm="6" md="4">
              <span> Tipo de seguro: {{ ArraySeguros.DescTipoSeguro }}</span>
            </v-col>
            <!--Poliza:-->
            <v-col cols="12" sm="6" md="4">
              <span> Poliza: {{ ArraySeguros.Poliza }} </span>
            </v-col>
            <!-- Anexo:-->
            <v-col cols="12" sm="6" md="4">
              <span> Anexo: {{ ArraySeguros.Anexo }} </span>
            </v-col>
            <!--Estado de poliza:-->
            <v-col cols="12" sm="6" md="4">
              <span>
                Estado de poliza: {{ ArraySeguros.DescEstadoPoliza }}
              </span>
            </v-col>
            <!--Tipo de poliza-->
            <v-col cols="12" sm="6" md="4">
              <span> Tipo de poliza: {{ ArraySeguros.DescTipoPoliza }} </span>
            </v-col>
            <!--Clase de poliza-->
            <v-col cols="12" sm="6" md="4">
              <span> Clase de poliza: {{ ArraySeguros.DescClasePoliza }} </span>
            </v-col>
            <!--Fecha Inicio-->
            <v-col cols="12" sm="6" md="4">
              <span> Fecha Inicio:{{ ArraySeguros.FechaInicial }} </span>
            </v-col>
            <!--Fecha Fin-->
            <v-col cols="12" sm="6" md="4">
              <span> Fecha Fin: {{ ArraySeguros.FechaFinal }}</span>
            </v-col>
            <!--Valor Aegurado-->
            <v-col cols="12" sm="6" md="4">
              <span> Valor Asegurado: {{ ArraySeguros.ValorAsegurado }}</span>
            </v-col>
            <!--Valor Prima-->
            <v-col cols="12" sm="6" md="4">
              <span> Valor Prima: {{ ArraySeguros.ValorPrima }}</span>
            </v-col>
            <!--Aseguradora-->
            <v-col cols="12" sm="6" md="6">
              <span>
                Aseguradora: {{ ArraySeguros.DocumentIDAseguradora }} -
                {{ ArraySeguros.NombreAseguradora }}</span
              >
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="12" md="12">
              <span> No existe seguro, debe crear uno. </span>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Comparendos ////////////////////////////////////////////////////////////-->
      <v-expansion-panel v-else-if="TipoServicio == 7">
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-lock </v-icon>
            Comparendos contrato {{ infollaves.Contrato }} activo
            {{ infollaves.Ref_1 }}
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Departamento-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.Departamento_ID"
                :items="ArrayDpto_ID"
                :item-title="
                  (ArrayDpto_ID) =>
                    ArrayDpto_ID.IDDepartamemto + '-' + ArrayDpto_ID.Nombre
                "
                item-value="IDDepartamemto"
                color="primary"
                label="Departamento :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :update:modelValue="ChangeDepto_ID()"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Ciudad-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.Ciudad_ID"
                :items="ArrayCiudad_ID"
                :item-title="
                  (ArrayCiudad_ID) =>
                    ArrayCiudad_ID.CityID + '-' + ArrayCiudad_ID.NombreCiudad
                "
                item-value="CityID"
                color="primary"
                label="Ciudad:"
                dense
                clearable
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!--Comparendo -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.Comparendo_ID"
                label="ID Comparendo:"
                hint="Digite Información"
                dense
                clearable
                maxlength="50"
                counter="50"
              >
              </v-text-field>
            </v-col>
            <!--Resolución -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.Resolucion"
                label="Resolución:"
                hint="Digite Información"
                dense
                clearable
                maxlength="50"
                counter="50"
              >
              </v-text-field>
            </v-col>
            <!-- Fecha Resolución -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.Fecha_Resolucion"
                label="Fecha resolución:"
                clearable
                dense
                type="date"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--//////////////////////////////////////////////  Zona Soporte ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-note-text-outline </v-icon>
            Zona Soporte
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Estado revisión-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.EstadoRevision"
                :items="ArrayEstado"
                :item-title="
                  (ArrayEstado) =>
                    ArrayEstado.EstadoID + '-' + ArrayEstado.Descripcion
                "
                item-value="EstadoID"
                color="primary"
                label="Estado Revisión:"
                dense
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                :update:modelValue="ChangeEstadoRevision()"
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!--Medio revisión-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.MedioRevision"
                :items="ArrayRevision"
                :item-title="
                  (ArrayRevision) =>
                    ArrayRevision.Valor + '-' + ArrayRevision.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Medio Revisión:"
                dense
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!--Número de factura/Cuenta de cobro/Estado de cuenta-->
            <v-col cols="12" sm="6" md="12">
              <v-text-field
                v-model="editedItem.NumeroFactura"
                label="Número de factura/Cuenta de cobro/Estado de cuenta"
                hint="Digite Información"
                dense
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                maxlength="100"
                counter="100"
              >
              </v-text-field>
            </v-col>
            <!-- Detalles de mora -->
            <v-col
              v-if="editedItem.EstadoRevision == '2'"
              cols="12"
              sm="6"
              md="12"
            >
              <v-expansion-panels v-model="panelmora" multiple>
                <!-- Zona de mora -->
                <v-expansion-panel :style="styleObject">
                  <v-expansion-panel-title>
                    <h2 align="center">
                      <v-icon color="#B6332E" large> mdi-alert-rhombus </v-icon>
                      Zona de Mora
                    </h2>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-row>
                      <!-- Fecha inicio de mora -->
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="editedItem.InicioMora"
                          label="Fecha Inicio de mora:"
                          :clearable="infopermisos == '1000' ? false : true"
                          :readonly="infopermisos == '1000' ? true : false"
                          dense
                          @change="getCalculoDias()"
                          type="date"
                          :rules="[(v) => !!v || 'Campo obligatorio']"
                        >
                        </v-text-field>
                      </v-col>
                      <!-- Valor en mora -->
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.ValorMora"
                          label="Valor en mora:"
                          :clearable="infopermisos == '1000' ? false : true"
                          :readonly="infopermisos == '1000' ? true : false"
                          dense
                          :rules="[(v) => !!v || 'Campo obligatorio']"
                          type="tel"
                          v-on:keypress="isNumber()"
                        ></v-text-field>
                      </v-col>
                      <!-- Cuotas en mora -->
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.PeriodosMora"
                          label="Cuotas en mora:"
                          readonly
                          type="tel"
                          v-on:keypress="isNumber()"
                          dense
                        ></v-text-field>
                      </v-col>
                      <!-- Días mora a la fecha de validación -->
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model="editedItem.DiasMoraFechaValidacion"
                          label="Días mora a la fecha actual:"
                          readonly
                          dense
                          :rules="[(v) => !!v || 'Campo obligatorio']"
                        ></v-text-field>
                      </v-col>
                      <!-- Detalles de mora -->
                      <v-col cols="12" sm="6" md="12">
                        <v-expansion-panels multiple accordion>
                          <v-expansion-panel :style="styleObject">
                            <v-expansion-panel-title>
                              <h4 align="center">
                                <v-icon color="#B6332E">
                                  mdi-alert-rhombus
                                </v-icon>
                                Detalle de la mora
                              </h4>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                              <!-- Valor cuota mes actual -->
                              <v-row>
                                <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                    v-model="editedItem.ValorCuotaMensual"
                                    label="Valor cuota mes actual:"
                                    :clearable="
                                      infopermisos == '1000' ? false : true
                                    "
                                    :readonly="
                                      infopermisos == '1000' ? true : false
                                    "
                                    dense
                                    type="tel"
                                    v-on:keypress="isNumber()"
                                  ></v-text-field>
                                </v-col>
                                <!-- Valor cuota periodico en mora -->
                                <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                    v-model="editedItem.ValorCuotaPeriodica"
                                    label="Valor cuota periodico en mora:"
                                    :clearable="
                                      infopermisos == '1000' ? false : true
                                    "
                                    :readonly="
                                      infopermisos == '1000' ? true : false
                                    "
                                    dense
                                    type="tel"
                                    v-on:keypress="isNumber()"
                                  ></v-text-field>
                                </v-col>
                                <!-- Valor cuota extraordinaria -->
                                <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                    v-model="editedItem.ValorCuotaExtra"
                                    label="Valor cuota extraordinaria:"
                                    :clearable="
                                      infopermisos == '1000' ? false : true
                                    "
                                    :readonly="
                                      infopermisos == '1000' ? true : false
                                    "
                                    dense
                                    type="tel"
                                    v-on:keypress="isNumber()"
                                  ></v-text-field>
                                </v-col>
                                <!-- Valor interes -->
                                <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                    v-model="editedItem.ValorCuotaInteres"
                                    label="Valor intereses:"
                                    :clearable="
                                      infopermisos == '1000' ? false : true
                                    "
                                    :readonly="
                                      infopermisos == '1000' ? true : false
                                    "
                                    dense
                                    type="tel"
                                    v-on:keypress="isNumber()"
                                  ></v-text-field>
                                </v-col>
                                <!-- Otros Conceptos -->
                                <v-col cols="12" sm="6" md="6">
                                  <v-text-field
                                    v-model="editedItem.ValorOtros"
                                    label="Otros conceptos:"
                                    :clearable="
                                      infopermisos == '1000' ? false : true
                                    "
                                    :readonly="
                                      infopermisos == '1000' ? true : false
                                    "
                                    dense
                                    type="tel"
                                    v-on:keypress="isNumber()"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>

            <!-- Detalles de Titularidad -->
            <v-col v-if="TipoServicio == 3" cols="12" sm="6" md="12">
              <v-expansion-panels v-model="paneltitularidad" multiple>
                <!-- Zona de Titularidad -->
                <v-expansion-panel>
                  <v-expansion-panel-title>
                    <h2 align="center">
                      <v-icon color="success" large>
                        mdi-account-child-outline
                      </v-icon>
                      Titularidad
                    </h2>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-row>
                      <!--Tipo de documento-->
                      <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                          v-model="editedItem.TypeDocumentIDFactura"
                          :items="ArrayTypeDocument_ID"
                          :item-title="
                            (ArrayTypeDocument_ID) =>
                              ArrayTypeDocument_ID.Valor +
                              '-' +
                              ArrayTypeDocument_ID.Descripcion
                          "
                          item-value="Valor"
                          color="primary"
                          label="Tipo de documento Titular:"
                          dense
                          clearable
                        >
                        </v-autocomplete>
                      </v-col>
                      <!--Documento-->
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.DocumentIDFactura"
                          label="Documento Titular"
                          hint="Digite Información"
                          dense
                          clearable
                          maxlength="20"
                          counter="20"
                        >
                        </v-text-field>
                      </v-col>
                      <!--Nombre-->
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.NombreFactura"
                          label="Nombre Titular:"
                          hint="Digite Información"
                          dense
                          clearable
                          maxlength="20"
                          counter="20"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>

            <!--Usuario revisión:-->
            <v-col cols="12" sm="6" md="6">
              <span> Usuario revisión: {{ editedItem.UsuarioRevision }}</span>
            </v-col>

            <!--Fecha revisión:-->
            <v-col cols="12" sm="6" md="6">
              <span>
                Fecha revisión: {{ editedItem.FechaRevision }}
                {{ editedItem.HoraRevision }}</span
              >
            </v-col>
            <!-- Fecha corte del soporte -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.PagoOportuno"
                label="Fecha corte del soporte:"
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                dense
                @change="getCalculoDias()"
                type="date"
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-text-field>
            </v-col>

            <!-- Valor Factura -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model.number="editedItem.ValorFactura"
                label="Valor Factura:"
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                dense
                type="tel"
                v-on:keypress="isNumber()"
              >
              </v-text-field>
            </v-col>

            <!-- Valor cuota mes actual -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model.number="editedItem.ValorCuotaMensual"
                label="Valor cuota mes actual:"
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                dense
                type="tel"
                v-on:keypress="isNumber()"
              ></v-text-field>
            </v-col>

            <!-- Valor cuota extraordinaria -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model.number="editedItem.ValorCuotaExtra"
                label="Valor cuota extraordinaria:"
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                dense
                type="tel"
                v-on:keypress="isNumber()"
              ></v-text-field>
            </v-col>

            <!-- Fecha Descuento -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.PagoDescuento"
                label="Fecha Descuento:"
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                dense
                type="date"
              >
              </v-text-field>
            </v-col>

            <!--Valor Descuento -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.ValorOtros"
                label="Valor Descuento:"
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                dense
                type="tel"
                v-on:keypress="isNumber()"
              >
              </v-text-field>
            </v-col>

            <!-- Fecha pagado -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.FechaRealPago"
                label="Fecha Pago:"
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                dense
                type="date"
              >
              </v-text-field>
            </v-col>

            <!--Valor Pagado -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model.number="editedItem.ValorPagadoFactura"
                label="Valor Pagado:"
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
                dense
                type="tel"
                v-on:keypress="isNumber()"
              >
              </v-text-field>
            </v-col>
            <!--Responsable-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.RealizoPago"
                :items="ArrayResponsablePago"
                :item-title="
                  (ArrayResponsablePago) =>
                    ArrayResponsablePago.Valor +
                    '-' +
                    ArrayResponsablePago.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Responsable:"
                dense
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
              >
              </v-autocomplete>
            </v-col>
            <!--Tipo de observación-->
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                v-model="editedItem.TipoObservacion"
                :items="ArrayTipoObservacion"
                :item-title="
                  (ArrayTipoObservacion) =>
                    ArrayTipoObservacion.TipoObservacion +
                    '-' +
                    ArrayTipoObservacion.DescTipoObservacion
                "
                item-value="TipoObservacion"
                color="primary"
                label="Tipo de observación:"
                dense
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
              >
              </v-autocomplete>
            </v-col>
            <!-- Observaciones -->
            <v-col cols="12" sm="6" md="12">
              <v-textarea
                v-model="editedItem.ObservacionRevision"
                name="input-7-1"
                filled
                label="Observaciones adicionales:"
                auto-grow
                :clearable="infopermisos == '1000' ? false : true"
                :readonly="infopermisos == '1000' ? true : false"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        :disabled="infopermisos == '1000' ? true : false"
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Seguros from "@/views/TCI/ActivosO/Seguros/Seguros.vue";
export default {
  name: "soporte_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    infollaves: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    llavesiframe: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    paramiframeuno: {
      type: String,
      default: "0",
      Description: "Parametro enviado de la pantalla principal",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
    infopermisos: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  components: {
    "card-seguros": Seguros,
  },
  data() {
    return {
      panel: [0, 1],
      panelmora: [0],
      paneltitularidad: [0],
      progreso: false,
      modelhojas: null,
      dialogframeboton: false,
      consult: false,
      TipoServicio: null,
      TipoSeguro: null,
      styleObject: { border: "5px solid #B6332E" },
      sheet: [
        {
          icono: "mdi-reply-all-outline",
          descripcion: "Replicar por Contrato/Activo",
          iconoelegido: 1,
        },
        {
          icono: "mdi-map-marker-distance",
          descripcion: "Replicación por Departamento - Ciudad/Municipio",
          iconoelegido: 2,
        },
        {
          icono: "mdi-account",
          descripcion: "Clientes",
          iconoelegido: 3,
        },
        {
          icono: "mdi-note",
          descripcion: "Contratos",
          iconoelegido: 4,
        },
        {
          icono: "mdi-home-group",
          descripcion: "Activos",
          iconoelegido: 5,
        },
        {
          icono: "mdi-account-lock",
          descripcion: "Seguros",
          iconoelegido: 6,
        },
        {
          icono: "mdi-folder-open",
          descripcion: "Anexar Documento",
          iconoelegido: 7,
        },
        {
          icono: "mdi-file-search",
          descripcion: "Consulta documentos",
          iconoelegido: 8,
        },
      ],
      buttonSave: false,
      editedItem: {
        Soporte_ID: null,
        Ref_1: null,
        Servicio_ID: null,
        EstadoRevision: null,
        NovedadRevision: null,
        MedioRevision: null,
        FechaProyectada: null,
        RealizoPago: null,
        TypeDocumentIDFactura: null,
        DocumentIDFactura: null,
        NombreFactura: null,
        FechaPago: null,
        NombreFuncionario: null,
        CodigoVerificacion: null,
        NumeroFactura: null,
        FechaCorte: null,
        PagoDescuento: null,
        InicioPagoOportuno: null,
        PagoOportuno: null,
        PagoSuspencion: null,
        PagoReal: null,
        InicioPeriodo: null,
        FinPeriodo: null,
        ValorFactura: 0,
        ValorPagadoFactura: 0,
        InicioMora: null,
        DiasMoraFechaValidacion: null,
        PeriodosMora: null,
        ValorMora: 0,
        ValorCuotaMensual: 0,
        ValorCuotaPeriodica: 0,
        ValorCuotaExtra: 0,
        ValorCuotaInteres: 0,
        ValorOtros: 0,
        TipoObservacion: null,
        ObservacionRevision: null,
        Pais_ID: "169",
        Departamento_ID: null,
        Ciudad_ID: null,
        Comparendo_ID: null,
        Resolucion: null,
        Fecha_Resolucion: null,
        EstadoPago: null,
        FechaRealPago: null,
        CuentaCobro: null,
        FechaAutorizacionPago: null,
        TipoObservacionPago: null,
        ObservacionRevisionPago: null,
        UsuarioRevision: null,
        FechaRevision: null,
        HoraRevision: null,
        Seguro_ID: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      defaultItem: {
        Soporte_ID: null,
        Ref_1: null,
        Servicio_ID: null,
        EstadoRevision: null,
        NovedadRevision: null,
        MedioRevision: null,
        FechaProyectada: null,
        RealizoPago: null,
        TypeDocumentIDFactura: null,
        DocumentIDFactura: null,
        NombreFactura: null,
        FechaPago: null,
        NombreFuncionario: null,
        CodigoVerificacion: null,
        NumeroFactura: null,
        FechaCorte: null,
        PagoDescuento: null,
        InicioPagoOportuno: null,
        PagoOportuno: null,
        PagoSuspencion: null,
        PagoReal: null,
        InicioPeriodo: null,
        FinPeriodo: null,
        ValorFactura: 0,
        ValorPagadoFactura: 0,
        InicioMora: null,
        DiasMoraFechaValidacion: null,
        PeriodosMora: null,
        ValorMora: 0,
        ValorCuotaMensual: 0,
        ValorCuotaPeriodica: 0,
        ValorCuotaExtra: 0,
        ValorCuotaInteres: 0,
        ValorOtros: null,
        TipoObservacion: null,
        ObservacionRevision: null,
        Pais_ID: "169",
        Departamento_ID: null,
        Ciudad_ID: null,
        Comparendo_ID: null,
        Resolucion: null,
        Fecha_Resolucion: null,
        EstadoPago: null,
        FechaRealPago: null,
        CuentaCobro: null,
        FechaAutorizacionPago: null,
        TipoObservacionPago: null,
        ObservacionRevisionPago: null,
        UsuarioRevision: null,
        FechaRevision: null,
        HoraRevision: null,
        Seguro_ID: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
      },
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      llavesData: {
        TypeDocument_ID: "",
        Document_ID: "",
        Primer_Apellido: "",
        Segundo_Apellido: "",
        Primer_Nombre: "",
        Segundo_Nombre: "",
        Solicitud: "",
        Contrato: "",
        Ref_1: "",
        Ref_2: "",
        Ref_3: "",
        IDServicio: "",
        IDPoliza: "",
        Secuencia_ID: "",
        UsuarioLogin: "",
        EntradaReportes: {
          Reporte: 0,
          Origen: "S", // Sistema
          Parametros: [],
        },
      },
      ArrayEstado: [],
      ArrayRevision: [],
      ArrayResponsablePago: [],
      ArrayTipoObservacion: [],
      ArrayDpto_ID: [],
      ArrayCiudad_ID: [],
      ArraySeguros: null,
      wdpto: null,
      westadorevision: null,
    };
  },
  watch: {
    dialogframeboton(val) {
      if (!val) {
        this.editedItem.Seguro_ID = null;
        this.getInfoSeguro();
      }
    },
  },
  methods: {
    // Convertir a numero
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Item editar
    editItem(item, dato) {
      var data = true;
      this.$emit("update:componenteview", item.iconoelegido);
      this.$emit("update:iconodialogbtn", item.icono);
      this.$emit("update:titledialogbtn", item.descripcion);
      this.$emit("update:pageiframe", data);
      switch (item.iconoelegido) {
        case 3: //Clientes
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          break;
        case 4: //Contratos
          this.llaves.Contrato = this.infollaves.Contrato;
          break;
        case 5: //Activos
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          break;
        case 6: //Seguros
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          break;
        case 7:
        case 8:
          this.llaves.TypeDocument_ID = this.infollaves.TypeDocument_ID;
          this.llaves.Document_ID = this.infollaves.Document_ID;
          this.llaves.Contrato = this.infollaves.Contrato;
          this.llaves.Ref_1 = this.infollaves.Ref_1;
          this.llaves.IDServicio = this.infollaves.IDServicio;
          var Soporte = 0;
          if (dato != undefined && dato != null) {
            Soporte = dato;
          } else {
            Soporte = item.Soporte_ID;
          }
          this.llaves.Secuencia_ID = Soporte;
          break;
      }
      this.$emit("update:llavesiframe", this.llaves);
    },
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        this.editedItem.Ref_1 == "" ||
        this.editedItem.Ref_1 == null ||
        this.editedItem.Servicio_ID == "" ||
        this.editedItem.Servicio_ID == null ||
        this.editedItem.EstadoRevision == "" ||
        this.editedItem.EstadoRevision == null ||
        this.editedItem.MedioRevision == "" ||
        this.editedItem.MedioRevision == null ||
        this.editedItem.UsuarioRevision == "" ||
        this.editedItem.UsuarioRevision == null ||
        this.editedItem.FechaRevision == "" ||
        this.editedItem.FechaRevision == null ||
        this.editedItem.HoraRevision == "" ||
        this.editedItem.HoraRevision == null
      ) {
        validate = true;
      } else if (
        this.TipoServicio == 6 &&
        (this.editedItem.Seguro_ID == "0" ||
          this.editedItem.Seguro_ID == "" ||
          this.editedItem.Seguro_ID == null)
      ) {
        validate = true;
      } else if (
        this.TipoServicio == 7 &&
        (this.editedItem.Departamento_ID == "" ||
          this.editedItem.Departamento_ID == null ||
          this.editedItem.Ciudad_ID == "" ||
          this.editedItem.Ciudad_ID == null)
      ) {
        validate = true;
      } else if (
        this.editedItem.EstadoRevision == 2 &&
        (this.editedItem.InicioMora == "" ||
          this.editedItem.InicioMora == null ||
          this.editedItem.ValorMora == "" ||
          this.editedItem.ValorMora == null ||
          this.editedItem.DiasMoraFechaValidacion == 0 ||
          this.editedItem.DiasMoraFechaValidacion == "" ||
          this.editedItem.DiasMoraFechaValidacion == null ||
          this.editedItem.DiasMoraFechaValidacion <= 0)
      ) {
        validate = true;
      } else if (
        this.editedItem.EstadoRevision != 2 &&
        (this.editedItem.PagoOportuno == "" ||
          this.editedItem.PagoOportuno == null)
      ) {
        validate = true;
      } else if (
        this.editedItem.EstadoRevision == 2 &&
        this.editedItem.DiasMoraFechaValidacion <= 0
      ) {
        validate = true;
      }

      // Validamos que si el estado es revision de mora, los días de mora sean equivalentes a 30 días.
      const diasMora = Number(this.editedItem.DiasMoraFechaValidacion);

      var permisos = this.infopermisos.split("");
      if (diasMora % 30 !== 0 && permisos.length >= 5 && permisos[4] == "1") {
        this.$swal({
          icon: "warning",
          title: "Fecha de Mora Incorrecta.",
          html: " Los días de mora deben ser múltiplos de 30, por favor cambie la fecha Inicio de Mora o Corte del Soporte para ajustar los días en mora.",
        });
        return;
      }

      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;

        // Vaidamos si es mora mayor a 90 haga una advertencia si la fecha de proceso actual es mayor a la fecha de corte
        var fechaPagoOportuno = new Date(this.editedItem.PagoOportuno);
        var fechaRevision = new Date(this.editedItem.FechaRevision);

        if (
          this.editedItem.EstadoRevision == 2 &&
          this.editedItem.DiasMoraFechaValidacion >= 90 &&
          fechaPagoOportuno < fechaRevision &&
          this.editedItem.Servicio_ID == 4
        ) {
          this.$swal({
            icon: "question",
            title: "Advertencia",
            html: "¿Esta seguro de guardar el registro? La fecha del corte de soporte es menor a la fecha de revisión.",
            confirmButtonText: "Sí",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
          }).then((result) => {
            if (result.isConfirmed) {
              if (this.editedIndex != -1) {
                this.putRegistro();
              } else {
                this.postRegistro();
              }
            }
          });
        } else {
          if (this.editedIndex != -1) {
            this.putRegistro();
          } else {
            this.postRegistro();
          }
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      // Llaves
      this.llavesData.TypeDocument_ID = this.infollaves.TypeDocument_ID;
      this.llavesData.Document_ID = this.infollaves.Document_ID;
      this.llavesData.Contrato = this.infollaves.Contrato;
      this.llavesData.Ref_1 = this.infollaves.Ref_1;
      this.llavesData.IDServicio = this.infollaves.IDServicio;
      this.llavesData.Primer_Nombre = this.infollaves.Primer_Nombre;
      this.llavesData.UsuarioLogin = this.editedItem.UsuarioCreacion;

      // Data
      var data = {
        historicoSoportes: this.editedItem,
        informacionLlaves: this.llavesData,
      };

      console.log(data);

      this.axios
        .post("/ActivosO/HistoricoSoportes/CR0/", data)
        .then((result) => {
          var data = {
            icono: "mdi-folder-open",
            descripcion: "Anexar Documento",
            iconoelegido: 7,
          };
          this.editItem(data, result.data[1]);
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data[0]);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      this.axios
        .put("/ActivosO/HistoricoSoportes/UP0", this.editedItem)
        .then((response) => {
          this.editedItem = this.defaultItem;
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Get Información Seguros
    async getInfoSeguro() {
      this.ArraySeguros = null;
      if (
        (this.infollaves.TypeDocument_ID != "" &&
          this.infollaves.TypeDocument_ID != null &&
          this.infollaves.Document_ID != "" &&
          this.infollaves.Document_ID != null &&
          this.infollaves.Contrato != "" &&
          this.infollaves.Contrato != null &&
          this.infollaves.Ref_1 != "" &&
          this.infollaves.Ref_1 != null) ||
        (this.editedItem.Seguro_ID != "" && this.editedItem.Seguro_ID != null)
      ) {
        var Seguro_ID =
          this.editedItem.Seguro_ID != "" && this.editedItem.Seguro_ID != null
            ? this.editedItem.Seguro_ID
            : 0;
        this.axios
          .get(
            "/ActivosO/Seguros/GetSeguroEspecifico/" +
              this.infollaves.TypeDocument_ID +
              "/" +
              this.infollaves.Document_ID +
              "/" +
              this.infollaves.Contrato +
              "/" +
              this.infollaves.Ref_1 +
              "/" +
              Seguro_ID +
              "/" +
              this.TipoSeguro +
              "/" +
              this.paramiframeuno,
          )
          .then((response) => {
            this.ArraySeguros = response.data;
            debugger;
            this.editedItem.Seguro_ID = this.ArraySeguros.SeguroID;
            if (this.TipoServicio == 6 && this.editedIndex == -1) {
              this.editedItem.EstadoRevision = 20;
              this.editedItem.PagoOportuno = this.ArraySeguros.FechaFinal;
              this.editedItem.ValorFactura = this.ArraySeguros.ValorPrima;
            }
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          });
      }
    },

    // Get Calculo Días
    async getCalculoDias() {
      this.ArraySeguros = null;
      if (
        this.editedItem.InicioMora != "" &&
        this.editedItem.InicioMora != null &&
        this.editedItem.PagoOportuno != "" &&
        this.editedItem.PagoOportuno != null
      ) {
        this.axios
          .get(
            "/ActivosO/HistoricoSoportes/CalculoDias?fechaInicio=" +
              this.editedItem.InicioMora +
              "&fechaFin=" +
              this.editedItem.PagoOportuno,
          )
          .then((response) => {
            this.editedItem.PeriodosMora = response.data.Periodo;
            this.editedItem.DiasMoraFechaValidacion = response.data.Dias;
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          });
      }
    },

    // Get Informacion Ultimo Soporte
    async getInfosSoportes() {
      this.ArraySeguros = null;
      if (
        this.infollaves.Ref_1 &&
        this.infollaves.IDServicio &&
        this.TipoServicio == 3
      ) {
        this.axios
          .get(
            "/ActivosO/HistoricoSoportes/GetInfosSoportes?RefActivo=" +
              this.infollaves.Ref_1 +
              "&Servicio=" +
              this.infollaves.IDServicio,
          )
          .then((response) => {
            this.editedItem.TypeDocumentIDFactura =
              response.data.TypeDocumentIDFactura;
            this.editedItem.DocumentIDFactura = response.data.DocumentIDFactura;
            this.editedItem.NombreFactura = response.data.NombreFactura;
          })
          .catch((error) => {
            const registro = error.response.data;
            const mensajeerror =
              registro.Mensaje || registro.ExceptionMessage || registro;
            switch (error.response.status) {
              case 404:
                this.$swal({
                  icon: "warning",
                  title: "Consulta inexistente.",
                  html: mensajeerror,
                });
                break;
              default:
                this.$swal({
                  icon: "error",
                  title: "Error al consultar",
                  html:
                    " El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                    mensajeerror +
                    "</code></small>",
                });
                break;
            }
          });
      }
    },
    /////////////////////////////////////////////// Métodos Changes ///////////////////////////////////////////////
    // Función de gestion cambio
    ChangePais_ID() {
      this.ArrayDpto_ID = [];
      this.editedItem.Departamento = null;
      this.getDpto_ID();
    },
    // Get para obtener array de los departamento existentes
    getDpto_ID() {
      if (this.editedItem.Pais_ID == "169") {
        this.ArrayDpto_ID = [];
        var ArrayDpto_ID2 = this.$store.getters.MGeografico.DE;
        this.ArrayDpto_ID = ArrayDpto_ID2.filter(
          (item) => item.IDDepartamemto != 0,
        );
      }
    },
    // Función de gestion cambio
    ChangeDepto_ID() {
      if (this.wdpto != this.editedItem.Departamento_ID) {
        this.wdpto = this.editedItem.Departamento_ID;
        if (
          this.editedItem.Departamento_ID == "" ||
          this.editedItem.Departamento_ID == null
        ) {
          this.ArrayCiudad_ID = [];
          this.editedItem.Ciudad_ID = null;
        } else {
          this.getCiudad_ID();
        }
      }
    },
    // Get para obtener array de las ciudades existentes
    getCiudad_ID() {
      if (
        this.editedItem.Departamento_ID != "" &&
        this.editedItem.Departamento_ID != null
      ) {
        this.ArrayCiudad_ID = [];
        var Dpto = this.editedItem.Departamento_ID;
        var ArrayCiudad_ID2 = this.$store.getters.MGeografico.DE[Dpto].VC;
        this.ArrayCiudad_ID = ArrayCiudad_ID2.filter(
          (item) => item.CityID != 0,
        );
      }
    },
    // Función de Estado de revisión
    ChangeEstadoRevision() {
      if (this.westadorevision != this.editedItem.EstadoRevision) {
        this.westadorevision = this.editedItem.EstadoRevision;
        if (
          this.editedItem.EstadoRevision == "" ||
          this.editedItem.EstadoRevision == null
        ) {
          this.editedItem.InicioMora = null;
          this.editedItem.ValorMora = null;
          this.editedItem.DiasMoraFechaValidacion = null;
          this.editedItem.PeriodosMora = null;
          //this.editedItem.ValorCuotaMensual = null;
          //this.editedItem.ValorCuotaExtra = null;
          //this.editedItem.ValorCuotaInteres = null;
          //this.editedItem.ValorOtros = null;
          //this.editedItem.ValorCuotaPeriodica = null;
        } else {
          if (this.editedItem.EstadoRevision != 2) {
            this.editedItem.InicioMora = null;
            this.editedItem.ValorMora = null;
            this.editedItem.DiasMoraFechaValidacion = null;
            this.editedItem.PeriodosMora = null;
            //this.editedItem.ValorCuotaMensual = null;
            //this.editedItem.ValorCuotaExtra = null;
            //this.editedItem.ValorCuotaInteres = null;
            //this.editedItem.ValorOtros = null;
            //this.editedItem.ValorCuotaPeriodica = null;
          }
        }
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.ArraySeguros = null;
      this.wdpto = null;
    },
    // Cargue Combos
    CargueCombos() {
      // Array Tipo Documento
      var TipoDocumento = this.$store.getters.MTablaSeleccion;
      this.ArrayTypeDocument_ID = TipoDocumento.filter(
        (item) => item.Valor != null && item.TablaId == 2,
      ).map((item) => ({
        ...item,
        Valor: parseInt(item.Valor), // o Number(item.Valor) si lo prefieres
      }));

      // Array Estado
      this.ArrayEstado = this.$store.getters.MREstadoServicio.filter(
        (item) => item.ServicioID == this.infollaves.IDServicio,
      );

      // Array Medio de revisión
      this.ArrayRevision = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 55,
      );

      this.ArrayTipoObservacion = this.$store.getters.MRObservacionServicio;

      this.ArrayTipoObservacion = this.ArrayTipoObservacion.filter(
        (item) => item.ServicioID == this.infollaves.IDServicio,
      ).map((item) => ({
        ...item,
        TipoObservacion: parseInt(item.TipoObservacion), // o Number(item.Valor) si prefieres mantener decimales
      }));

      var ResponsablePago = this.$store.getters.MTablaSeleccion;
      this.ArrayResponsablePago = ResponsablePago.filter(
        (item) => item.Valor != null && item.TablaId == 58,
      ).map((item) => ({
        ...item,
        Valor: parseInt(item.Valor), // o Number(item.Valor) si prefieres mantener decimales
      }));

      // Tipo de servicio comparendos
      if (this.TipoServicio == 7) {
        this.ChangePais_ID();
      }
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      } else {
        this.getInfosSoportes();
        if (this.infollaves != null) {
          this.editedItem.Ref_1 =
            this.infollaves.Ref_1 != null ? this.infollaves.Ref_1 : null;
          this.editedItem.Servicio_ID =
            this.infollaves.IDServicio != null
              ? this.infollaves.IDServicio
              : null;
        }
        // Usuario de revisión
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioRevision = userperfil.userInfo.Usuario_ID;

        // Fecha y Hora de revisión
        var fechaHora = new Date();
        var horas = fechaHora.getHours();
        var minutos = fechaHora.getMinutes();
        if (horas < 10) {
          horas = "0" + horas;
        }
        if (minutos < 10) {
          minutos = "0" + minutos;
        }
        this.editedItem.HoraRevision = horas + ":" + minutos;

        this.editedItem.FechaRevision =
          this.$store.getters.userperfil.userInfo.FechasCierre.FechaProcesoActual.replace(
            "T00:00:00",
            "",
          );
      }
      // Traer ultimo seguro del soporte
      if (this.TipoServicio == 6) {
        // Tipo de seguro
        var ArrayServices = this.$store.getters.MServicio.filter(
          (item) => item.ServicioID == this.infollaves.IDServicio,
        );
        this.TipoSeguro = ArrayServices[0].TipoSeguro;
        this.getInfoSeguro();
      }
    },
  },
  mounted() {
    // Tipo servicio
    var ArrayServices = this.$store.getters.MServicio.filter(
      (item) => item.ServicioID == this.infollaves.IDServicio,
    );
    this.TipoServicio = ArrayServices[0].TipoServicio;

    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
